import { QueryString, objectToUrlQuery, formatMoney } from '../functions';

$(document).ready(function() {
    const order = {
        isLoadingOrder: false,
        init() {
            $(document).on('click', '#send-reservation-btn', this, this.sendForm);
            $(document).on('change', '#person-type', this, this.selectPersonType);
            //$(document).on('click', '.billing-company', this, this.selectBillingCompany);
            $(document).on('click', '.payment-method-input', this, this.selectPaymentMethod);

            $(document).on('click', '#add-new-billing-company', this, this.addNewCompanyModal);

			$('.order-payment-wrapper .form-check').click(function(){
		        $('.order-payment-wrapper .form-check').removeClass("selected");
		        $('.order-payment-wrapper .form-check-input').prop('checked', false);
		        $(this).addClass("selected");
		        $(this).find(".form-check-input").prop('checked', true);
		    });

			$(document).on('click', '.change-car-options', function(e) {
				var parameters = QueryString(null);

				var url = objectToUrlQuery(parameters);
				window.location = selectExtrasRoute + (url != '' ? '?' + url : '');
			});
        },
		sendForm(event) {
			const _this = event.data;

			if (this.isLoadingOrder) {
				return false;
			}

			$('#reservation-form').submit();
		},
		selectPersonType(event) {
			const _this = event.data;

			if ($(this).is(':checked')) {
				$('#company-container').show();
			} else {
				$('#company-container').hide();
			}
		},
		selectBillingCompany(event) {
			const _this = event.data;
			var id = $(this).data('id');
			if(!id) { return false; }

			$('.billing-company').find('.radio-box').removeClass('selected');
			$(this).find('.radio-box').addClass('selected');

			$('#billing_company').val(id);
		},
		selectPaymentMethod(event) {
			const _this = event.data;

			let total = mainTotal;

			if($(this).data('has-discount') == '1' && $(this).data('discount-value') > 0) {
				total = 1*total - 1*$(this).data('discount-value');

				var html = `<div class="float-start">${$(this).data('label-discount')}</div>
					<div class="float-end">&euro; -${formatMoney($(this).data('discount-value'), 2, '.', ' ')} (${$(this).data('discount')}%)</div>`;

				$('.payment-method-discount-wrapper').html(html);
			} else {
				$('.payment-method-discount-wrapper').html('');
			}

			$('.total').html(formatMoney(total, 2, '.', ' '));
		},
		addNewCompanyModal(event) {
			const _this = event.data;

			$.ajax({
                type: "GET",
                url: `${baseURL}/account/company?source=reservation-page`,
				success: function(response, xhr) {
                    $('#billing-company-modal').html(response);
                    $('#billing-company-modal').modal('show');
                },
                error(error) {
                    console.log(error);
                },
			});
		}
    };

    if ($('.order-page').length) {
        order.init();
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/reservation.js